import styled from 'styled-components'

const StyledAvatar = styled.div`
  flex-shrink: 0;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  user-select: none;
  background-color: ${({ theme }) => theme.color.gray[900]};
  color: ${({ theme }) => theme.color.background};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  padding-left: 1px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export default StyledAvatar
